import axios from 'axios';

export const postMessage = (kind, data) => {
  window.parent.postMessage(
    JSON.stringify({
      kind,
      ...data,
    }),
    '*',
  );
};

/**
 * Fires to Lambda API in order to compare captcah response with captcha secret key.
 * @param {string} appName an app name set in the lambda. Required to relate to captcha secret key.
 * @param {string} captchaResponse string returned from captcha field on the form.
 * @returns {Promise}
 */
export const validateCaptcha = (appName, captchaResponse) =>
  axios.post(
    `https://4czg62ral1.execute-api.us-east-1.amazonaws.com/production/validate?app=${appName}&response=${captchaResponse}`,
  );
